import React from 'react';
import MarkerIcon from 'images/icons/controls/map-marker.svg?react-svg';
import IconContainer from '../IconContainer';

export default function Icon() {
  return (
    <IconContainer>
      <MarkerIcon width={20} />
    </IconContainer>
  );
}
